import {
  faArrowLeft,
  faArrowRight,
  faCarSide,
  faCheck,
  faCircle,
  faCircleCheck,
  faEarth,
  faFile,
  faFileAlt,
  faSeedling,
  faTrafficLight,
} from '@fortawesome/free-solid-svg-icons';
import { Divider, Radio } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import RadioButton from '@material-ui/core/Radio';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useCollection } from '../../utility/hooks/useCollection';
import { handleChangeController } from '../../redux/actions/form';
import { StatusContext } from '../../utility/context/StatusContext';

export const FormCalculator = (props) => {
  const [activeIndex, setActiveIndex] = useContext(StatusContext);
  const { form } = useSelector((state) => state);
  const nodeForm = useCollection().getCollectionNode(form, []);
  const [addTraficReport, setAddTraficReport] = useState(
    nodeForm['addTraficReport'] || false,
  );
  const [addEnvironmentalBadge, setAddEnvironmentalBadge] = useState(
    nodeForm['addEnvironmentalBadge'] || false,
  );
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();

  const handleChange = (id) => {
    if (id === 0) {
      setAddTraficReport(!addTraficReport);
      dispatch(handleChangeController('addTraficReport', !addTraficReport));
    } else {
      setAddEnvironmentalBadge(!addEnvironmentalBadge);
      dispatch(
        handleChangeController('addEnvironmentalBadge', !addEnvironmentalBadge),
      );
    }
  };

  const calculatePrice = () => {
    let total = 110;
    if (!!form.itp?.itp) {
      total += form.itp?.itp;
    }
    if (addEnvironmentalBadge) {
      total += 9;
    }
    if (addTraficReport) {
      total += 12;
    }

    setTotal(total.toFixed(2));
    dispatch(handleChangeController('total', total));
  };

  useEffect(() => {
    calculatePrice();
  }, [addEnvironmentalBadge, addTraficReport, form.itp]);

  return (
    <>
      <Card>
        <CardBody className="row">
          <div
            className="col-12 col-xs-12 col-md-6 col-lg-6 mr-1 row"
            style={{ borderRight: '1px #ebe9f1 solid' }}
          >
            <div className="col-8">
              <h4 style={{ fontWeight: 'bold' }}>Cambio de Nombre</h4>
            </div>
            <div className="col-4" style={{ textAlign: 'end' }}>
              <h6 style={{ fontWeight: 'bold' }}>110 €</h6>
            </div>
            <div className="col-12">
              <h6 style={{ fontWeight: 'bold' }}>Incluye :</h6>
            </div>
            <div className="col-12 mb-1">
              <ul>
                {/* <li><h6>Tasas DGT - {form?.itp?.itp?.toFixed(2)} €</h6></li> */}
                <li>
                  <h6>Gestión + Tasas DGT - 110 €</h6>
                </li>
                {/* <li><h6>IVA - {(total * 0.21).toFixed(2)}€ </h6></li> */}
                <li>
                  <h6>Envío a domicilio - Gratuito </h6>
                </li>
              </ul>
            </div>
            <div className="col-8">
              <h6>Impuesto de transmisiones</h6>
            </div>
            <div className="col-4" style={{ textAlign: 'end' }}>
              <h6 style={{ fontWeight: 'bold' }}>
                {form?.itp?.itp?.toFixed(2)} €
              </h6>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-md-6 col-lg-6 row pr-0">
            <div className="col-12">
              <h6>¿Quieres añadir algo mas?</h6>
            </div>
            <div className="col-6">
              <div
                className="border w-100 row justify-content-center cursor-pointer p-0"
                style={{
                  backgroundColor: addTraficReport && '#ef641733',
                  borderRadius: '5px',
                }}
                onClick={() => handleChange(0)}
              >
                <RadioButton
                  color={'secondary'}
                  size="medium"
                  style={{ pointerEvents: 'none' }}
                  name={name}
                  checkedIcon={
                    <div>
                      <FontAwesomeIcon
                        color="#EF6417"
                        icon={faFileAlt}
                        size={'2x'}
                      />
                      <p
                        className="m-0"
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: addTraficReport && '#EF6417',
                        }}
                      >
                        Informe de tráfico
                      </p>
                      <p
                        className="m-0"
                        style={{
                          textAlign: 'center',
                          color: addTraficReport && '#EF6417',
                        }}
                      >
                        (+12 €)
                      </p>
                    </div>
                  }
                  icon={
                    <div>
                      <FontAwesomeIcon icon={faFileAlt} size={'2x'} />
                      <p
                        className="m-0"
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: addTraficReport && '#EF6417',
                        }}
                      >
                        Informe de tráfico
                      </p>
                      <p
                        className="m-0"
                        style={{
                          textAlign: 'center',
                          color: addTraficReport && '#EF6417',
                        }}
                      >
                        (+12 €)
                      </p>
                    </div>
                  }
                  checked={addTraficReport}
                  onChange={() => handleChange(0)}
                />
              </div>
            </div>
            <div className="col-6 pr-0">
              <div
                className="border w-100 row justify-content-center cursor-pointer"
                style={{
                  backgroundColor: addEnvironmentalBadge && '#ef641733',
                  borderRadius: '5px',
                }}
                onClick={() => handleChange(1)}
              >
                <RadioButton
                  color={'secondary'}
                  size="medium"
                  style={{ pointerEvents: 'none' }}
                  name={name}
                  checkedIcon={
                    <div>
                      <FontAwesomeIcon
                        color="#EF6417"
                        icon={faEarth}
                        size={'2x'}
                      />
                      <p
                        className="m-0"
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: addEnvironmentalBadge && '#EF6417',
                        }}
                      >
                        Distintivo medioambiental
                      </p>
                      <p
                        className="m-0"
                        style={{
                          textAlign: 'center',
                          color: addEnvironmentalBadge && '#EF6417',
                        }}
                      >
                        (+9.90 €)
                      </p>
                    </div>
                  }
                  icon={
                    <div>
                      <FontAwesomeIcon icon={faEarth} size={'2x'} />
                      <p
                        className="m-0"
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: addEnvironmentalBadge && '#EF6417',
                        }}
                      >
                        Distintivo medioambiental
                      </p>
                      <p
                        className="m-0"
                        style={{
                          textAlign: 'center',
                          color: addEnvironmentalBadge && '#EF6417',
                        }}
                      >
                        (+9.90 €)
                      </p>
                    </div>
                  }
                  checked={addEnvironmentalBadge}
                  onChange={() => handleChange(1)}
                />
              </div>
            </div>
            <hr style={{ width: '97%' }} />
            <div className="col-6 d-flex">
              <h4 style={{ fontWeight: 'bold' }}>Total</h4>
            </div>
            <div className="col-6" style={{ textAlign: 'end' }}>
              <h4 style={{ fontWeight: 'bold' }}>{total} €</h4>
            </div>
          </div>
        </CardBody>
      </Card>
      <div className="row">
        <div className="col-6" style={{ textAlign: 'left' }}>
          <Button
            onClick={() => setActiveIndex(activeIndex - 1)}
            color="primary"
          >
            Atras{' '}
            <FontAwesomeIcon
              style={{ marginLeft: '3px' }}
              icon={faArrowLeft}
              size={'1x'}
            />
          </Button>
        </div>
        <div className="col-6" style={{ textAlign: 'right' }}>
          <Button
            onClick={() => setActiveIndex(activeIndex + 1)}
            color="primary"
          >
            Siguiente{' '}
            <FontAwesomeIcon
              style={{ marginLeft: '3px' }}
              icon={faArrowRight}
              size={'1x'}
            />
          </Button>
        </div>
      </div>
    </>
  );
};
